


























































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import {
    postUser,
    getUser,
    patchUser,
    getCompanies,
    postPrescriberDocumentAdmin,
    getPrescriberDocumentAdmin,
    getBusinessDevelopers,
    postSubscriptionCreate,
    postSubscriptionForm,
    putSubscriptionForm,
    generateContract,
    getContracts,
    requestPassword
} from '@/api/api';

import Subscription from '@/models/Subscription';


import User from '@/models/User';
import moment from 'moment';
import Company from '../models/Company';
import get from 'lodash/get';
import countries from '@/data/countries';
import FileCurrent from '../models/FileCurrent';
import { saveAs } from 'file-saver';
import { DOCUMENT_PRESCRIBER_TYPE } from '../data/documentPrescriberTypes';
import { Route } from 'vue-router';
import { BACKEND_URL } from '@/helpers/constants';
import UserUserTokenList from '@/components/UserUserTokenList.vue';
import Axios from 'axios';
const url = process.env.VUE_APP_ACADEMY_URL;
const key = process.env.VUE_APP_ACADEMY_KEY;

interface DocValue {
    type: DOCUMENT_PRESCRIBER_TYPE;
    current: string;
}

interface DocRequest {
    type: DOCUMENT_PRESCRIBER_TYPE;
    name: string;
    content: string;
}

let user: User | null = null;

async function computeBreadcrumb(to: Route, from: Route, next: Function) {
    try {
        const { data: userObj } = await getUser(+to.params.id);
        user = userObj;

        to.meta.breadcrumb[2].title = `${user.lastname} ${user.firstname}`;
    } catch (error) {
        if (error.response.status == 404) {
            Vue.prototype.$vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Prescripteur introuvable.`,
            });

            next({
                name: 'prescribers',
            });
            return;
        }
    }

    next();
}

@Component({
    beforeRouteEnter: computeBreadcrumb,
    beforeRouteUpdate: computeBreadcrumb,
    components: {
        Forms,
        UserUserTokenList,
    },
})
export default class PrescriberForm extends Vue {
    popupAccess: Boolean = false;
    user: User | null = user;
    companiesItems: Array<{ text: string; value: number }> = [];
    businessDeveloppers: Array<{ text: string; value: number }> = [];
    loading: boolean = false;
    errors: any = {};
    documentsSectionName = 'Documents PlugIMMO';
    documentsCreditSectionName = 'Documents PlugCredit';
    documentsFinanceSectionName = 'Documents PlugFinance';
    securitySectionName = 'Sécurité et confidentialité';
    defaultImages: any | null = null;
    resetPasswordPopup: boolean = false;
    contracts: any = [];
    contractPopup = false;





    commissionRate!: number;
    lastSubscriptionExists: boolean = false;


    async sendPasswordReset() {
        this.resetPasswordPopup = true;
}
cancelResetPassword() {
    this.resetPasswordPopup = false;
}

async confirmSendPasswordReset() {
    const $vs = (this as any).$vs;
    if (this.user && this.user.email) {
        try {
            this.loading = true;
            
            // Passer isAdmin=true pour indiquer que la demande vient du backoffice
            await requestPassword(this.user.email, true);
            
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Réinitialisation de mot de passe',
                text: `Un email de réinitialisation de mot de passe a été envoyé à ${this.user.email}`,
            });
        } catch (error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: get(
                    error,
                    'response.data.message',
                    'Erreur lors de l\'envoi de l\'email de réinitialisation'
                ),
            });
        } finally {
            this.loading = false;
            this.resetPasswordPopup = false;
        }
    }
}
    async createPlugAcademyAccess() {
        if (this.user) {
            const passwordGenerated = Math.random().toString(36).slice(-8);
            const $vs = (this as any).$vs;

            const newUserAcademy: any = {
                lastname: this.user.lastname,
                firstname: this.user.firstname,
                email: this.user.email,
                password: passwordGenerated,
                token: key
            }

            try {
                const { data } = await Axios.post(`${url}/api/register`, newUserAcademy, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json'
                    }
                });

                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Création',
                    text: `Utilisateur PlugAcademie Crée`,
                });
            } catch (e) {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: e.response.data.message ? e.response.data.message : `Erreur lors de la création de l'utilisateur PlugAcademie`,
                });
            }
        }
    }

    async createAccess(isJc: boolean) {
        let type: string = this.$route.name === 'addUser' ? 'add' : 'edit';
        if (this.user && this.user.id && type === 'edit') {
            const $vs = (this as any).$vs;
            try {
                await postSubscriptionCreate(this.user.id, isJc);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Création',
                    text: `Création de l'abonnement réussie`,
                });
            } catch (e) {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Création',
                    text: `Erreur lors de la création de l'abonnement`,
                });
            }
            this.popupAccess = false
        }
    }

    get isMandat() {
        let ret = true;
        if (this.user && this.user.documents) {
            this.user.documents.forEach(el => {
                console.log(el.type);
                if (el.type == "contract_plugimmo") {
                    console.log('ok');
                    ret = false;
                }
            })
        }
        return ret;
    }

    get type(): 'edit' | 'add' {
        return this.$route.name === 'addUser' ? 'add' : 'edit';
    }
    get items() {
        return [
            {
                name: 'civility',
                label: 'Civilité *',
                type: 'select',
                errorMessage: 'La civilité est requise',
                required: true,
                items: [
                    { text: 'Monsieur', value: 'Monsieur' },
                    { text: 'Madame', value: 'Madame' },
                ],
            },
            {
                name: 'firstname',
                label: 'Prénom *',
                type: 'text',
                errorMessage: 'Le prénom est requis',
                required: true,
            },
            {
                name: 'lastname',
                label: 'Nom *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                required: true,
            },
            {
                name: 'email',
                label: 'Email *',
                type: 'text',
                errorMessage: "L'email est requis",
                required: true,
            },
            {
                name: 'password',
                label: 'Mot de passe *',
                type: 'password',
                errorMessage: 'Le mot de passe est requis',
                hidden: this.type === 'edit',
                required: true,
            },
            {
                name: 'company',
                label: 'Entreprise',
                type: 'select',
                items: this.companiesItems,
            },
            {
                name: 'roles',
                label: 'Rôle *',
                type: 'select',
                multiple: true,
                required: true,
                items: [
                    { text: 'Administrateur', value: 'ROLE_ADMIN' },
                    { text: 'Prescripteur', value: 'ROLE_PRESCRIBER' },
                    { text: 'Manager', value: 'ROLE_MANAGER' },
                    { text: 'Opérateur', value: 'ROLE_OPERATOR' },
                ],
            },
            {
                name: 'birthdate',
                label: 'Date de naissance',
                type: 'date',
            },
            {
                name: 'phone',
                label: 'Tel. fixe',
                type: 'text',
            },
            {
                name: 'mobile',
                label: 'Tel. mobile',
                type: 'text',
            },
            {
                name: 'address',
                type: 'address',
                fields: {
                    street: {
                        label: 'Adresse',
                        name: 'street',
                        errorMessage: "L'adresse est requise",
                        required: true,
                    },
                    street2: {
                        label: `Complément d'adresse`,
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal',
                        name: 'postal_code',
                        errorMessage: 'Le code postal est requis',
                        required: true,
                    },
                    city: {
                        label: 'Ville',
                        name: 'city',
                        errorMessage: 'La ville est requise',
                        required: true,
                    },
                },
            },
            {
                name: 'business_developper',
                label: 'Business Developer *',
                type: 'select',
                items: this.businessDeveloppers,
                errorMessage: "Le Business Developer est requis",
                required: true,
            },
            {
                name: 'siren',
                label: 'SIREN',
                type: 'siren',
            },
            {
                name: 'family',
                label: 'Famille de Prescripteur *',
                type: 'select',
                required: true,
                items: [
                    { text: 'A déterminer', value: '' },
                    { text: 'CGP avec carte T', value: 'CGP avec carte T' },
                    { text: 'CGP Mandataire', value: 'CGP Mandataire' },
                    {
                        text: 'Conseiller Immo9 avec carte T',
                        value: 'Conseiller Immo9 avec carte T',
                    },
                    {
                        text: 'Conseiller Immo9 sans carte T',
                        value: 'Conseiller Immo9 sans carte T',
                    },
                    { text: 'CIF', value: 'CIF' },
                    {
                        text: 'Agent immo ancien avec carte T',
                        value: 'Agent immo ancien avec carte T',
                    },
                    {
                        text: 'Agent immo ancien sans carte T',
                        value: 'Agent immo ancien sans carte T',
                    },
                    {
                        text: 'Agent Général d’Assurance',
                        value: 'Agent Général d’Assurance',
                    },
                    {
                        text: 'Agent immobilier avec Carte T ou Mandataire immobilier sans carte T',
                        value: 'Agent immobilier avec Carte T ou Mandataire immobilier sans carte T',
                    },
                    {
                        text: 'Avocat Fiscaliste',
                        value: 'Avocat Fiscaliste',
                    },
                    {
                        text: 'Commercialisateur d’Immobilier Neuf avec ou sans Carte T',
                        value: 'Commercialisateur d’Immobilier Neuf avec ou sans Carte T',
                    },
                    {
                        text: 'Conseiller en Gestion de Patrimoine CGP avec ou sans Carte T',
                        value: 'Conseiller en Gestion de Patrimoine CGP avec ou sans Carte T',
                    },
                    {
                        text: 'Conseiller en Investissement Financier CIF avec ou sans Carte T',
                        value: 'Conseiller en Investissement Financier CIF avec ou sans Carte T',
                    },
                    {
                        text: 'Courtier en Prêt immobilier',
                        value: 'Courtier en Prêt immobilier',
                    },
                    {
                        text: 'Expert Comptable',
                        value: 'Expert Comptable',
                    },
                ],
            },
            {
                name: 'tool_interest',
                label: 'Interet pour l\'outils *',
                type: 'select',
                required: false,
                items: [
                    { text: 'Cat1: Inscription imminente', value: 'registered' },
                    { text: 'Cat2: Besoin outil court terme -1 mois', value: 'short' },
                    { text: 'Cat3: Besoin outil Moyen terme + 6 mois', value: 'mid' },
                    { text: 'Cat4: Pas de besoin outil', value: 'no_one' },
                ],
            },
            {
                name: 'registration_origin',
                label: 'Origine de l’inscription *',
                required: true,
                type: 'select',
                items: [
                    { text: 'A déterminer', value: '' },
                    {
                        text: 'Bouche à oreille',
                        value: '?',
                    },
                    {
                        text: 'Prospection LinkedIn / SMS',
                        value: 'Prospection LinkedIn / SMS',
                    },
                    {
                        text: 'Prospection phoning BDD',
                        value: 'Prospection phoning BDD',
                    },
                    {
                        text: 'Emailing / SMS Sendinblue',
                        value: 'Emailing / SMS Sendinblue',
                    },
                    {
                        text: 'Prospection emailing BDD',
                        value: 'Prospection emailing BDD',
                    },
                    {
                        text: 'Prospection SMS BDD',
                        value: 'Prospection SMS BDD',
                    },
                    {
                        text: 'Contact via Salon Immo',
                        value: 'Contact via Salon Immo',
                    },
                    {
                        text: 'Site PlugIMMO via pub facebook',
                        value: 'site PlugIMMO via pub facebook',
                    },
                    {
                        text: 'Site PlugIMMO via pub linkedin',
                        value: 'site PlugIMMO via pub linkedin',
                    },
                    {
                        text: 'Site PlugIMMO Via Pub Instagram',
                        value: 'Site PlugIMMO Via Pub Instagram',
                    },
                    {
                        text: 'Site PlugIMMO Via Google Ads',
                        value: 'Site PlugIMMO Via Google Ads',
                    },
                    {
                        text: 'Site PlugIMMO Via Google ref. Naturel',
                        value: 'Site PlugIMMO Via Google ref. Naturel',
                    },
                    {
                        text: 'Parrainage',
                        value: 'Parrainage',
                    },
                    { text: 'Autres', value: 'autres' },
                ],
            },
            {
                name: 'autonomous',
                label: '100% Autonome ?',
                type: 'select',
                items: [
                    { text: 'À déterminer', value: 'À déterminer' },
                    { text: 'OUI', value: 'OUI' },
                    { text: 'NON', value: 'NON' },
                ],
            },
            {
                name: 'personnal_company',
                label: 'Entreprise prescripteur ?',
                type: 'select',
                required: true,
                items: [
                    { text: 'SAS/SARL/etc..', value: 'other' },
                    { text: 'Entreprise Individuelle', value: 'individual_company' },
                    { text: 'Salarié', value: 'salary' },
                    { text: 'A demander', value: "to_request" }
                ],
            },
            {
                name: 'personnal_company_name',
                label: 'Nom de son entreprise',
                type: 'string',
                requires: ['personnal_company', 'other'],
            },
            {
                name: 'website',
                label: 'Site Web ?',
                type: 'select',
                required: true,
                items: [
                    { text: 'À déterminer', value: 'À déterminer' },
                    { text: 'Oui-site Avec immo9', value: 'OUI avec immo9' },
                    { text: 'Oui-site sans immo9', value: 'OUI sans immo9' },
                    { text: 'NON', value: 'NON' },
                    { text: 'A demander', value: "to_request" }
                ],
            },
            {
                name: 'website_url',
                label: 'URL Site Web',
                type: 'string',
                requires: ['website', 'OUI avec immo9'],
            },
            {
                name: 'website_url',
                label: 'URL Site Web',
                type: 'string',
                requires: ['website', 'OUI sans immo9'],
            },
            {
                name: 'linkedin_url',
                label: 'Profil Linkedin',
                type: 'string',
            },
            {
                name: 'comment',
                label: 'Commentaires',
                type: 'textarea',
                maxLength: 10000,
            },
            {
                name: 'subject_to_vat',
                label: 'Assujettis TVA *',
                type: 'select',
                required: true,
                items: [
                    { text: 'A déterminer', value: '' },
                    { text: 'Oui', value: 'yes' },
                    { text: 'Non', value: 'no' },
                    { text: 'A demander', value: "to_request" }
                ]
            },
            {
                name: 'demo_is_done',
                label: 'Démo complète',
                type: 'select',
                required: true,
                items: [
                    { text: 'Oui', value: 'yes' },
                    { text: 'Non', value: 'no' },
                    { text: 'A confirmer', value: 'to_confirm' },
                ]
            },
            {
                name: 'demo_date',
                label: 'Démo complète faite le',
                type: 'date',
                requires: ['demo_is_done', 'yes'],
            },
            {
                name: 'plugfinance_type',
                label: 'PlugFinance',
                type: 'select',
                items: [
                    { text: 'Mandataire assurance ailleurs', value: 'mandataire' },
                    { text: 'Courtier en assurance ailleurs', value: 'courtier' },
                    { text: 'Mandataire assurance PlugFinance', value: 'mandataire_plugfinance' },
                    { text: 'Courtier en assurance PlugFinance', value: 'courtier_plugfinance' },
                    { text: 'A determiner', value: '' },
                ]
            },
            {
                name: 'is_kochise',
                label: 'Accès à Kochise',
                type: 'switch',
            },
            {
                name: 'is_restricted',
                label: 'Offre Starter (Mode Restreint)',
                type: 'switch',
            },
            {
                name: 'logo',
                label: 'Logo image',
                type: 'image_as_array',
                slug: 'logoImage',
                accept: 'image/*',
            },

            //couleur perso
            {
                name: 'personal_color',
                label: 'Couleur personnalisée',
                type: 'color',
            },

            // documents
            {
                name: 'documents_identity_card',
                label: `CNI/Passeport`,
                type: 'custom-file',
                current: 'documents_identity_card_current',
                fields: {
                    name: 'documents_identity_card_name',
                    content: 'documents_identity_card_content',
                },
                section: this.documentsSectionName,
            },
            {
                name: 'documents_kbis',
                label: `KBIS Prescripteur`,
                type: 'custom-file',
                current: 'documents_kbis_current',
                fields: {
                    name: 'documents_kbis_name',
                    content: 'documents_kbis_content',
                },
                section: this.documentsSectionName,
            },
            {
                name: 'documents_rcp',
                label: `Responsabilité civile pro`,
                type: 'custom-file',
                current: 'documents_rcp_current',
                fields: {
                    name: 'documents_rcp_name',
                    content: 'documents_rcp_content',
                },
                section: this.documentsSectionName,
            },
            {
                name: 'documents_t_card',
                label: `Carte T/Carte Mandataire`,
                type: 'custom-file',
                current: 'documents_t_card_current',
                fields: {
                    name: 'documents_t_card_name',
                    content: 'documents_t_card_content',
                },
                section: this.documentsSectionName,
            },
            {
                name: 'documents_ursaff_cetificate',
                label: `Attestation Vigilance URSAFF`,
                type: 'custom-file',
                current: 'documents_ursaff_cetificate_current',
                fields: {
                    name: 'documents_ursaff_cetificate_name',
                    content: 'documents_ursaff_cetificate_content',
                },
                section: this.documentsSectionName,
            },
            {
                name: 'contract_plugimmo',
                label: `Contrat PlugIMMO avec ou sans carte T`,
                type: 'custom-file',
                current: 'contract_plugimmo_current',
                fields: {
                    name: 'contract_plugimmo_name',
                    content: 'contract_plugimmo_content',
                },
                section: this.documentsSectionName,
            },
            {
                name: 'sepa_mandat',
                label: `Mandat SEPA`,
                type: 'custom-file',
                current: 'sepa_mandat_current',
                fields: {
                    name: 'sepa_mandat_name',
                    content: 'sepa_mandat_content',
                },
                section: this.documentsSectionName,
            },
            {
                name: 'enabled',
                label: 'Vérifié',
                type: 'switch',
                hidden: this.docs(),
                section: this.documentsSectionName,
            },
            {
                name: 'convention_credit',
                label: `Convention apporteur d'affaires`,
                type: 'custom-file',
                current: 'convention_credit_current',
                fields: {
                    name: 'convention_credit_name',
                    content: 'convention_credit_content',
                },
                section: this.documentsCreditSectionName,
            },
            {
                name: 'other_credit',
                label: `Document autre`,
                type: 'custom-file',
                current: 'other_credit_current',
                fields: {
                    name: 'other_credit_name',
                    content: 'other_credit_content',
                },
                section: this.documentsCreditSectionName,
            },
            {
                name: 'convention_finance',
                label: `Convention contre signée indicateur d’affaires`,
                type: 'custom-file',
                current: 'convention_finance_current',
                fields: {
                    name: 'convention_finance_name',
                    content: 'convention_finance_content',
                },
                section: this.documentsFinanceSectionName,
            },
            {
                name: 'rcp_finance',
                label: `RCP mandataire PlugFINANCE`,
                type: 'custom-file',
                current: 'rcp_finance_current',
                fields: {
                    name: 'rcp_finance_name',
                    content: 'rcp_finance_content',
                },
                section: this.documentsFinanceSectionName,
            },
            {
                name: 'end_rcp_finance',
                label: ' date de fin RCP mandataire PlugFINANCE',
                type: 'date',
                section: this.documentsFinanceSectionName
            },
            {
                name: 'chambre_attestation_finance',
                label: `Attestation inscription chambre`,
                type: 'custom-file',
                current: 'chambre_attestation_finance_current',
                fields: {
                    name: 'chambre_attestation_finance_name',
                    content: 'chambre_attestation_finance_content',
                },
                section: this.documentsFinanceSectionName,
            },
            {
                name: 'end_chambre_attestation_finance',
                label: ' date de fin Attestation inscription chambre',
                type: 'date',
                section: this.documentsFinanceSectionName
            },
            {
                name: 'orias_finance',
                label: `Attestation ORIAS`,
                type: 'custom-file',
                current: 'orias_finance_current',
                fields: {
                    name: 'orias_finance_name',
                    content: 'orias_finance_content',
                },
                section: this.documentsFinanceSectionName,
            },
            {
                name: 'end_orias_finance',
                label: ' date de fin Attestation ORIAS',
                type: 'date',
                section: this.documentsFinanceSectionName,
            },
            {
                name: 'other_finance',
                label: `Document autre`,
                type: 'custom-file',
                current: 'other_finance_current',
                fields: {
                    name: 'other_finance_name',
                    content: 'other_finance_content',
                },
                section: this.documentsFinanceSectionName,
            },
        ];
    }
    defaultValue: any | null = {
        civility: null,
        firstname: null,
        lastname: null,
        company: null,
        roles: null,
        email: null,
        birthdate: null,
        phone: null,
        mobile: null,
        address: {
            street: null,
            street2: null,
            postal_code: null,
            city: null,
        },
        siren: null,
        business_developper: null,
        family: '',
        tool_interest: '',
        registration_origin: '',
        autonomous: '?',
        website: null,
        website_url: null,
        linkedin_url: null,
        personnal_company: null,
        personnal_company_name: null,
        comment: null,
        subject_to_vat: '',
        demo_is_done: false,
        plugfinance_type: '',
        demo_date: null,
        personal_color: null,
        enabled: false,
        is_kochise: false,
        is_restricted: false,
        documents_identity_card_current: null,
        documents_kbis_current: null,
        documents_rcp_current: null,
        documents_t_card_current: null,
        documents_ursaff_cetificate_current: null,
        contract_plugimmo_current: null,
        sepa_mandat_current: null,
        convention_credit_current: null,
        other_credit_current: null,
        convention_finance_current: null,
        other_finance_current: null,
        rcp_finance_current: null,
        chambre_attestation_finance_current: null,
        orias_finance_current: null,
        end_rcp_finance: null,
        end_chambre_attestation_finance: null,
        end_orias_finance: null
    };

    docs() {
        if (this.user) {
            if (this.user.documents && this.user.documents.length === 5) {
                return false
            }
            return true
        }
        return true
    }

    async generateContract(userId: any, contractId: any) {
        console.log('=========>')
        console.log(userId, contractId);
        const $vs = (this as any).$vs;

        generateContract(contractId, userId)
            .then((resp: any) => {
                console.log('resp', resp);
                const fileName = resp.headers['content-disposition'].split(
                    '"'
                )[1];
                console.log('fileName', fileName);
                try {
                    saveAs(resp.data, fileName);
                } catch (e) {
                    console.log('error', e);
                }
            })
            .catch(() => {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text:
                        'Une erreur est survenue lors de la récupération du contrat',
                });
            });
    }

    async created(): Promise<void> {
        const { data } = await getContracts();
        this.contracts = data;
        this.loading = true;
        const dataCompanies = await getCompanies();
        const companies = dataCompanies.data;
        this.companiesItems = companies.map((item: Company) => ({
            value: item.id || 0,
            text: item.name,
        }));

        const dataBusinessDeveloppers = await getBusinessDevelopers();
        this.businessDeveloppers = dataBusinessDeveloppers.data.map(
            (item: User) => ({
                text: item.firstname + " - " + item.email,
                value: item.id || 0,
            })
        );

        if (this.type === 'edit' && this.user) {
            // defaultValue
            this.defaultValue.civility = this.user.civility || null;
            this.defaultValue.firstname = this.user.firstname || null;
            this.defaultValue.lastname = this.user.lastname || null;
            this.defaultValue.company = this.user.company
                ? this.user.company.id
                : null;
            this.defaultValue.roles =
                (this.user.roles) || null;
            this.defaultValue.email = this.user.email || null;
            this.defaultValue.birthdate =
                (this.user.birthdate && moment(this.user.birthdate)) || null;
            this.defaultValue.phone = this.user.phone || null;
            this.defaultValue.mobile = this.user.mobile || null;
            this.defaultValue.address.street =
                (this.user.address && this.user.address.street) || null;
            this.defaultValue.address.street2 =
                (this.user.address && this.user.address.street2) || null;
            (this.defaultValue.address.postal_code =
                (this.user.address && this.user.address.postal_code) || null),
                (this.defaultValue.address.city =
                    (this.user.address && this.user.address.city) || null);
            this.defaultValue.siren = this.user.siren
                ? this.user.siren.toString()
                : null;
            this.defaultValue.business_developper = this.user
                .business_developper
                ? this.user.business_developper.id
                : null;
            this.defaultValue.family = this.user.family || '';
            this.defaultValue.tool_interest = this.user.tool_interest || '';
            this.defaultValue.registration_origin =
                this.user.registration_origin || '';
            this.defaultValue.website = this.user.website || 'À déterminer';
            this.defaultValue.website_url = this.user.website_url || null;
            this.defaultValue.linkedin_url = this.user.linkedin_url || null;
            this.defaultValue.personnal_company = this.user.personnal_company || null;
            this.defaultValue.personnal_company_name = this.user.personnal_company_name || null;
            this.defaultValue.autonomous =
                this.user.autonomous || 'À déterminer';
            this.defaultValue.comment = this.user.comment || null;
            this.defaultValue.subject_to_vat = this.user.subject_to_vat || '';
            this.defaultValue.demo_is_done = this.user.demo_is_done || '';
            this.defaultValue.plugfinance_type = this.user.plugfinance_type || '';
            this.defaultValue.demo_date =
                (this.user.demo_date && moment(this.user.demo_date)) || null;
            this.defaultValue.personal_color = this.user.personal_color || null;
            this.defaultValue.enabled = this.user.enabled;
            this.defaultValue.is_kochise = this.user.is_kochise;
            this.defaultValue.is_restricted = this.user.is_restricted;
            this.defaultImages =
                this.user.logo_image &&
                `${BACKEND_URL}${this.user.logo_image.url}${this.user.logo_image.name
                }.${this.user.logo_image.extension}`;
            this.defaultValue.end_rcp_finance =
                (this.user.end_rcp_finance && moment(this.user.end_rcp_finance)) || null;
            this.defaultValue.end_chambre_attestation_finance =
                (this.user.end_chambre_attestation_finance && moment(this.user.end_chambre_attestation_finance)) || null;
            this.defaultValue.end_orias_finance =
                (this.user.end_orias_finance && moment(this.user.end_orias_finance)) || null;

            const docs: DocValue[] = [
                {
                    type: 'documents_identity_card',
                    current: 'documents_identity_card_current',
                },
                {
                    type: 'documents_kbis',
                    current: 'documents_kbis_current',
                },
                {
                    type: 'documents_rcp',
                    current: 'documents_rcp_current',
                },
                {
                    type: 'documents_t_card',
                    current: 'documents_t_card_current',
                },
                {
                    type: 'documents_ursaff_cetificate',
                    current: 'documents_ursaff_cetificate_current',
                },
                {
                    type: 'contract_plugimmo',
                    current: 'contract_plugimmo_current',
                },
                {
                    type: 'sepa_mandat',
                    current: 'sepa_mandat_current',
                },
                {
                    type: 'convention_credit',
                    current: 'convention_credit_current',
                },
                {
                    type: 'other_credit',
                    current: 'other_credit_current',
                },
                {
                    type: 'convention_finance',
                    current: 'convention_finance_current',
                },
                {
                    type: 'other_finance',
                    current: 'other_finance_current',
                },
                {
                    type: 'rcp_finance',
                    current: 'rcp_finance_current',
                },
                {
                    type: 'chambre_attestation_finance',
                    current: 'chambre_attestation_finance_current',
                },
                {
                    type: 'orias_finance',
                    current: 'orias_finance_current',
                },
            ];

            // récupération des documents
            docs.forEach(doc => {
                if (!this.user || !this.user.documents) {
                    return;
                }

                const item = this.user.documents.find(
                    item => item.type === doc.type
                );

                if (item) {
                    const name = `${item.document.name}.${item.document.extension
                        }`;
                    const current: FileCurrent = {
                        name,
                        get: async () => {
                            if (!this.user) {
                                return;
                            }

                            const { data } = await getPrescriberDocumentAdmin(
                                this.user.id || -1,
                                doc.type
                            );

                            saveAs(data, name);
                        },
                    };

                    this.defaultValue[doc.current] = current;
                }
            });
        }

   

        if (this.user) {
                this.form.trial = !!this.user.is_trial_active;
                this.form.subscription = !!this.user.is_subscription_active;
                this.form.isRestricted = !!this.user.is_restricted;

                const last = this.getLastSubscription();
                if (last) {
                    this.form.isJc = !!last.is_jc;
                    this.form.withHono = !!last.with_hono;
                    this.form.commissionRate = parseFloat(String(last.commission_rate)) || 0;
                }
            }


        this.loading = false;
    }

    async submit(form: any) {
        this.loading = true;
        const newUser: User = {
            civility: form.civility,
            firstname: form.firstname,
            lastname: form.lastname,
            company: form.company,
            roles: form.roles,
            email: form.email,
            birthdate: form.birthdate,
            password: form.password === null ? undefined : form.password,
            phone: form.phone,
            mobile: form.mobile,
            address: {
                street: form.address.street,
                street2: form.address.street2,
                postal_code: form.address.postal_code,
                city: form.address.city,
            },
            business_developper: form.business_developper,
            siren: form.siren ? form.siren.replace(/ /g, '') : null,
            family: form.family,
            tool_interest: form.tool_interest,
            registration_origin: form.registration_origin,
            autonomous: form.autonomous,
            website: form.website,
            website_url: form.website_url,
            linkedin_url: form.linkedin_url,
            personnal_company: form.personnal_company,
            personnal_company_name: form.personnal_company_name,
            comment: form.comment,
            subject_to_vat: form.subject_to_vat,
            demo_is_done: form.demo_is_done,
            plugfinance_type: form.plugfinance_type,
            demo_date: form.demo_date,
            personal_color: form.personal_color,
            enabled: form.enabled,
            is_kochise: form.is_kochise,
            is_restricted: form.is_restricted ? true : false,
            logo_images: form.logo,
            end_rcp_finance: form.end_rcp_finance,
            end_orias_finance: form.end_orias_finance,
            end_chambre_attestation_finance: form.end_chambre_attestation_finance
        };

        const $vs = (this as any).$vs;
        let resp;
        try {
            // envoi de l'entité prescriber
            if (this.type === 'add') {
                resp = await postUser(newUser);
            } else {
                resp = await patchUser(+this.$route.params.id, newUser);
            }

            // envoi des documents
            const prescriber = resp.data;
            const docs: DocRequest[] = [
                {
                    type: 'documents_identity_card',
                    name: 'documents_identity_card_name',
                    content: 'documents_identity_card_content',
                },
                {
                    type: 'documents_kbis',
                    name: 'documents_kbis_name',
                    content: 'documents_kbis_content',
                },
                {
                    type: 'documents_rcp',
                    name: 'documents_rcp_name',
                    content: 'documents_rcp_content',
                },
                {
                    type: 'documents_t_card',
                    name: 'documents_t_card_name',
                    content: 'documents_t_card_content',
                },
                {
                    type: 'documents_ursaff_cetificate',
                    name: 'documents_ursaff_cetificate_name',
                    content: 'documents_ursaff_cetificate_content',
                },
                {
                    type: 'contract_plugimmo',
                    name: 'contract_plugimmo_name',
                    content: 'contract_plugimmo_content',
                },
                {
                    type: 'sepa_mandat',
                    name: 'sepa_mandat_name',
                    content: 'sepa_mandat_content',
                },
                {
                    type: 'convention_credit',
                    name: 'convention_credit_name',
                    content: 'convention_credit_content',
                },
                {
                    type: 'other_credit',
                    name: 'other_credit_name',
                    content: 'other_credit_content',
                },
                {
                    type: 'convention_finance',
                    name: 'convention_finance_name',
                    content: 'convention_finance_content',
                },
                {
                    type: 'other_finance',
                    name: 'other_finance_name',
                    content: 'other_finance_content',
                },
                {
                    type: 'rcp_finance',
                    name: 'rcp_finance_name',
                    content: 'rcp_finance_content',
                },
                {
                    type: 'chambre_attestation_finance',
                    name: 'chambre_attestation_finance_name',
                    content: 'chambre_attestation_finance_content',
                },
                {
                    type: 'orias_finance',
                    name: 'orias_finance_name',
                    content: 'orias_finance_content',
                },
            ];

            docs.forEach(async doc => {
                if (
                    prescriber &&
                    prescriber.id &&
                    form[doc.name] &&
                    form[doc.content]
                ) {
                    await postPrescriberDocumentAdmin(prescriber.id, doc.type, {
                        file_name: form[doc.name],
                        document: form[doc.content],
                    });
                }
            });

            if (this.type === 'add') {
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Création',
                    text: `Création de l'utilisateur réussie`,
                });
            } else {
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Modification',
                    text: `Modification de l'utilisateur réussie`,
                });
            }

            if (this.$route.name === 'editPrescriber') {
                this.$router.push({ name: 'prescribers' });
            } else {
                this.$router.push({ name: 'users' });
            }
        } catch (error) {
            this.errors = error.response.data.errors.children;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text:
                    error.response.data.errors.errors.length > 0
                        ? error.response.data.errors.errors[0]
                        : 'Erreur lors de la soumission du formulaire',
            });
        } finally {
            this.loading = false;
        }
    }


     // ************** Acces Code  **********************************************
           
                get isJcActive(): boolean {
                return this.isJc(this.user && this.user.subscriptions ? this.user.subscriptions : []);
            }

            set isJcActive(value: boolean) {
                // handled via updateJcStatus
            }


            get withHono(): boolean {
                    const sub = this.user && this.user.subscriptions ? this.user.subscriptions : [];
                    const last = sub.length > 0 ? sub[sub.length - 1] : null;
                    return last && typeof last.with_hono === 'boolean' ? last.with_hono : false;
                }



                set withHono(value: boolean) {
                        const sub = this.user && this.user.subscriptions ? this.user.subscriptions : [];
                        const last = sub.length > 0 ? sub[sub.length - 1] : null;
                        if (last) {
                            last.with_hono = value;
                        }
                    }


                


                   // Update your methods with proper TypeScript typing
                    getStatusClass(user: User): string {
                        const status = this.getPrescriberStatus(user);
                        if (status.includes('subscribed')) {
                            return 'subscribed';
                        } else if (status === 'trial') {
                            return 'trial';
                        } else if (status === 'outdated') {
                            return 'outdated';
                        } else {
                            return 'no-access';
                        }
                    }



                    updateTrialStatus(value: boolean): void {
                            console.log('Trial status changed:', value);
                            if (value) {
                                // Si trial = 1, alors subscription = 0
                                this.form.subscription = false;
                                this.form.isRestricted = false;
                                this.form.isJc = false;
                                this.form.withHono = false;
                                this.form.commissionRate = 0;
                            } else {
                                // Si trial = 0, alors subscription = 1 (on a forcément un abonnement)
                                this.form.subscription = true;
                                // Par défaut, on met Expert (is_restricted = false)
                                this.form.isRestricted = false;
                            }
                            // TODO: appel API
                        }

                        // Nouvelle méthode pour Expert
                        updateExpertStatus(event: Event): void {
                            const isChecked = (event.target as HTMLInputElement).checked;
                            console.log('Expert status changed:', isChecked);
                            
                            if (isChecked) {
                                // Activer Expert: subscription = 1, is_restricted = 0
                                this.form.subscription = true;
                                this.form.isRestricted = false;
                                this.form.withHono = false;
                                this.form.commissionRate = 0;
                            } else {
                                // Si on désactive Expert, on active automatiquement Starter
                                this.form.subscription = true;
                                this.form.isRestricted = true;
                                this.form.isJc = false;
                            }
                            // TODO: appel API
                        }

                        // Nouvelle méthode pour Starter
                        updateStarterStatus(event: Event): void {
                            const isChecked = (event.target as HTMLInputElement).checked;
                            console.log('Starter status changed:', isChecked);
                            
                            if (isChecked) {
                                // Activer Starter: subscription = 1, is_restricted = 1
                                this.form.subscription = true;
                                this.form.isRestricted = true;
                                this.form.isJc = false;
                            } else {
                                // Si on désactive Starter, on active automatiquement Expert
                                this.form.subscription = true;
                                this.form.isRestricted = false;
                                this.form.withHono = false;
                                this.form.commissionRate = 0;
                            }
                            // TODO: appel API
                        }

                     
                        


            updateJcStatus(value: boolean): void {
                console.log('JC status changed:', value);
                // TODO: appel API
            }

            updateHonoStatus(event: Event): void {
                    const input = event.target as HTMLInputElement;
                    const value = input.checked;
                    console.log('Hono status changed:', value);
                    this.withHono = value;
                    // TODO: appel API ici
                }


            getLastSubscription(): any {
                if (!this.user || !this.user.subscriptions || this.user.subscriptions.length === 0) {
                    this.lastSubscriptionExists = false;
                    return null;
                }
                this.lastSubscriptionExists = true;
                return this.user.subscriptions[this.user.subscriptions.length - 1];
            }

            formatSubscriptionDate(dateString: string): string {
                if (!dateString) return 'Non définie';
                return moment(dateString).format('DD/MM/YYYY');
            }

            getMonthSub(subscriptions: any[]): number {
                if (!subscriptions || subscriptions.length === 0) return 0;
                const last = subscriptions[subscriptions.length - 1];
                if (last.start_at && last.end_at) {
                    const start = new Date(last.start_at);
                    const end = new Date(last.end_at);
                    return (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
                }
                return 0;
            }

            isJc(subscriptions: any[]): boolean {
                if (!subscriptions || subscriptions.length === 0) return false;
                const last = subscriptions[subscriptions.length - 1];
                return last && last.is_jc ? true : false;
            }






            getPrescriberStatus(prescriber: any): string {
            if (prescriber && prescriber.is_subscription_active) {
                const sub = prescriber.subscriptions || [];
                if (sub.length > 0) {
                    const last = sub[sub.length - 1];
                    const endDate = last.end_at ? last.end_at.toString() : null;
                    const startDate = last.start_at ? last.start_at.toString() : null;

                    if (endDate !== null && startDate !== null) {
                        const end = new Date(endDate);
                        const start = new Date(startDate);
                        const diffYears = end.getFullYear() - start.getFullYear();
                        const diffMonths = end.getMonth() - start.getMonth();
                        const months = (diffYears * 12) + diffMonths;
                        return 'subscribed months_' + months;
                    }
                }
            } else if (prescriber && prescriber.is_trial_active) {
                return 'trial';
            } else {
                const sub = prescriber && prescriber.subscriptions ? prescriber.subscriptions : [];
                if (sub.length > 0) {
                    const last = sub[sub.length - 1];
                    const endDate = last.end_at ? last.end_at.toString() : null;
                    const startDate = last.start_at ? last.start_at.toString() : null;

                    if (endDate !== null && startDate !== null) {
                        const end = new Date(endDate);
                        const start = new Date(startDate);
                        const diffYears = end.getFullYear() - start.getFullYear();
                        const diffMonths = end.getMonth() - start.getMonth();
                        const months = (diffYears * 12) + diffMonths;
                        return 'Périmé ' + months + ' Mois';
                    }
                } else {
                    return 'outdated';
                }
            }

            return 'no_access';
        }




           

        form = {
                trial: false,
                subscription: false,
                isJc: false,
                isRestricted: false,  // This maps to is_restricted from your User interface
                withHono: false,
                commissionRate: 0
            };
                    
                    
                    submitted = false;
                    lastAction = '';  // "POST" ou "PUT"



                    onToggleHono(active: boolean) {
                        if (!active) this.form.commissionRate = 0;
                        }

                    incrementRate() {
                        this.form.commissionRate = Math.min(1,
                            Math.round((this.form.commissionRate + 0.01) * 100) / 100
                        );
                        }

                        decrementRate() {
                        this.form.commissionRate = Math.max(0,
                            Math.round((this.form.commissionRate - 0.01) * 100) / 100
                        );
                        }

                        
                        
                        async createNewAccess() {
                                this.lastAction = 'POST';
                                await this.sendPayload(postSubscriptionForm);
                            }

                            /** PUT → modification du dernier accès */
                            async modifyLastAccess() {
                                const last = this.getLastSubscription();
                                if (!last || !last.id) {
                                return (this as any).$vs.notify({ color:'warning', title:'Aucun accès', text:'Pas de souscription existante' });
                                }
                                this.lastAction = 'PUT';
                                // on passe user.id & last.id à putSubscriptionForm
                                await this.sendPayload((userId, payload) =>
                                putSubscriptionForm(userId, last.id, payload)
                                );
                            }



                            /** logique partagée POST/PUT */
                            private async sendPayload(
                                fn: (userId: number, data: any) => Promise<any>
                            ) {
                                this.submitted = true;
                                if (!this.form.withHono) {
                                    this.form.commissionRate = 0;
                                }
                                if (!this.user || !this.user.id) return;

                                const payload = {
                                    is_trial_active: this.form.trial,
                                    is_subscription_active: this.form.subscription,  // Expert
                                    is_restricted: this.form.isRestricted,           // Starter
                                    is_jc: this.form.isJc,
                                    with_hono: this.form.withHono,
                                    commission_rate: this.form.commissionRate,
                                };

                                try {
                                    await fn(this.user.id, payload);
                                    (this as any).$vs.notify({ 
                                        color: 'success', 
                                        title: 'Succès', 
                                        text: 'Opération réussie' 
                                    });
                                    this.submitted = false;
                                } catch {
                                    (this as any).$vs.notify({ 
                                        color: 'danger', 
                                        title: 'Erreur', 
                                        text: 'Échec de l\'opération' 
                                    });
                                }
                            }



                             





}





